import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { OnInit } from '@angular/core';

@Component({
    selector: 'app-countdown-v3',
    templateUrl: './countdown-v3.component.html',
    styleUrls: ['./countdown-v3.component.scss']
})
export class CountdownV3Component implements OnInit
{
    @Output() public timerDone = new EventEmitter();
    @Input('countdownDate') public date: Date;

    public days = '--';
    public hours = '--';
    public minutes = '--';
    public seconds = '--';

    public hLineWidth: number;
    public mLineWidth: number;
    public sLineWidth: number;

    private timer: any;

    public ngOnInit(): void
    {
        this.timer = setInterval(() =>
        {
            this.determineContentForDisplay();
        }, 1000);
    }
    
    public ngOnChanges(changes: SimpleChanges): void
    {
        this.date = changes.date.currentValue;
    }

    private update(date: Date): void
    {
        if(date == null)
        {
            return;
        }

        const currentDate = new Date();

        if (date.getTime() - currentDate.getTime() <= 0)
        {
            this.timerDone.emit();
        } else
        {
            this.setDisplayValues(date, currentDate);
        }
    }

    private getCountdownValues(date: Date, currentDate: Date): { days: number, hours: number, minutes: number, seconds: number }
    {
        let values = this.translateTimespan(date, currentDate);
        
        const testDate = new Date(currentDate);
        testDate.setDate(testDate.getDate() + values.days);
        testDate.setHours(testDate.getHours() + values.hours);
        testDate.setMinutes(testDate.getMinutes() + values.minutes);
        testDate.setSeconds(testDate.getSeconds() + values.seconds);
        
        var calculatedDiff = testDate.getTime() - date.getTime();

        // Daylight saving time can result in a calculated difference of +- 1 hour. 
        // Check with half an hour difference.
        if(Math.abs(calculatedDiff) > 1800000)
        {
            values = this.translateTimespan(new Date(date.getTime() - calculatedDiff), currentDate);
        }
        
        return values;
    }

    private translateTimespan(date, currentDate): { days: number, hours: number, minutes: number, seconds: number }
    {
        const difference = date.getTime() - currentDate.getTime(); // (unix epoch time)

        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        return {
            days,
            hours,
            minutes,
            seconds
        }
    }

    private setDisplayValues(date: Date, currentDate: Date)
    {
        const values = this.getCountdownValues(date, currentDate);
        const timez = [
            ('0' + values.days).slice(-2),
            ('0' + values.hours).slice(-2),
            ('0' + values.minutes).slice(-2),
            ('0' + values.seconds).slice(-2)
        ];

        if (this.minutes === '--')
        {
            setTimeout(() =>
            {
                this.days = timez[0].slice(0, 1);

                setTimeout(() =>
                {
                    this.days = timez[0].slice(0);
                    
                    setTimeout(() =>
                    {
                        this.hours = timez[1].slice(0, 1);

                        setTimeout(() =>
                        {
                            this.hours = timez[1].slice(0);
                            
                            setTimeout(() =>
                            {
                                this.minutes = timez[2].slice(0, 1);

                                setTimeout(() =>
                                {
                                    this.minutes = timez[2].slice(0);

                                    setTimeout(() =>
                                    {
                                        this.seconds = timez[3].slice(0, 1);

                                        setTimeout(() =>
                                        {
                                            this.seconds = timez[3].slice(0);
                                        }, 67);
                                    }, 67);
                                }, 67);
                            }, 67);
                        }, 67);
                    }, 67);
                }, 67);
            }, 10);

            return;
        }

        this.days = ('0' + values.days).slice(-2);
        this.hours = ('0' + values.hours).slice(-2);
        this.minutes = ('0' + values.minutes).slice(-2);
        this.seconds = ('0' + values.seconds).slice(-2);
        this.calcLineWidth(values.hours, values.minutes, values.seconds);
    }

    private calcLineWidth(h: number, m: number, s: number): void
    {
        this.sLineWidth = 100 * s / 60;
        this.mLineWidth = 100 * m / 60;
        this.hLineWidth = 100 * h / 24;
    }
    
    private updateCounter(): void
    {
        this.timer = setInterval(() =>
        {
            this.update(this.date);
        }, 1000);
    }

    private determineContentForDisplay(): void
    {
        this.updateCounter();
    }

    public ngOnDestroy(): void
    {
        if (this.timer)
        {
            clearInterval(this.timer);
        }
    }
}
